/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import { View, StyleSheet, Text } from '@react-pdf/renderer';
import { useTemplateColors } from 'PDF/TemplateEngine/TemplateColorsContext';

const useTableStyles = () => {
  const { colors } = useTemplateColors();
  return useMemo(
    () =>
      StyleSheet.create({
        tableContainer: {
          backgroundColor: colors.white,
          borderRadius: '0.3cm',
          border: `1px solid ${colors.border}`,
          overflow: 'hidden',
          boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        },
        headerContainer: {
          flexDirection: 'row',
          backgroundColor: colors.primary,
          borderBottom: `2px solid ${colors.darkText}`,
        },
        headerText: {
          fontFamily: 'Helvetica-Bold',
          fontSize: '11px',
          color: colors.white,
          textAlign: 'center',
          padding: '0.4cm 0.3cm',
          borderRight: '1px solid rgba(255,255,255,0.2)',
          textTransform: 'uppercase',
          letterSpacing: '0.3px',
        },
        rowContainer: {
          flexDirection: 'row',
          borderBottom: '1px solid #f0f0f0',
          backgroundColor: colors.white,
        },
        rowContainerAlt: {
          flexDirection: 'row',
          borderBottom: '1px solid #f0f0f0',
          backgroundColor: colors.lightBg,
        },
        rowText: {
          fontSize: '10px',
          color: colors.bodyText,
          textAlign: 'center',
          padding: '0.3cm 0.2cm',
          borderRight: '1px solid #f0f0f0',
          fontFamily: 'Helvetica',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        rowTextLeft: {
          fontSize: '10px',
          color: colors.bodyText,
          textAlign: 'left',
          padding: '0.3cm 0.2cm',
          borderRight: '1px solid #f0f0f0',
          fontFamily: 'Helvetica',
          display: 'flex',
          alignItems: 'center',
        },
      }),
    [colors]
  );
};

function TableHeader({ columns }) {
  const styles = useTableStyles();
  // `fixed` hace que el encabezado se repita en cada página cuando la tabla
  // se parte entre páginas (multi-página low-code PDF).
  return (
    <View style={styles.headerContainer} fixed>
      {columns.map((col) => (
        <Text key={col.key} style={[styles.headerText, { width: col.width }]}>
          {col.title}
        </Text>
      ))}
    </View>
  );
}

function TableRow({ items, columns }) {
  const styles = useTableStyles();
  return (
    <>
      {items.map((item, rowIndex) => (
        <View
          key={rowIndex}
          wrap={false}
          style={rowIndex % 2 === 0 ? styles.rowContainer : styles.rowContainerAlt}
        >
          {columns.map((col) => {
            const align =
              col.align ||
              (col.key === 'description' || col.key === 'descripcion' ? 'left' : 'center');
            const textStyle = align === 'left' ? styles.rowTextLeft : styles.rowText;

            return (
              <Text key={col.key} style={[textStyle, { width: col.width }]}>
                {item[col.key]}
              </Text>
            );
          })}
        </View>
      ))}
    </>
  );
}

function Table({ data, columns }) {
  const styles = useTableStyles();
  return (
    <View style={styles.tableContainer}>
      <TableHeader columns={columns} />
      <TableRow items={data} columns={columns} />
    </View>
  );
}

export default Table;
